export class Constants {
  static readonly TIMEZONE = 'UTC';
  static readonly EVENT_MINIMUM_DURATION = 10800000; //  3 hours
  static readonly EVENT_MAXIMUM_DURATION = 39600000; //  11  hours
}
